<form id="form" [formGroup]="form" (ngSubmit)="onSubmit()">
	<div class="row">
		<div class="col">
			<label for="name" class="form-label theme-main-color fw-bold">Nom</label>
			<input
				autocomplete="off"
				required
				type="text"
				class="form-control"
				id="name"
				name="name"
				formControlName="name"
				[ngClass]="{
					'is-invalid': name?.invalid && (name?.dirty || name?.touched),
					'is-valid': name?.dirty && name?.valid
				}"
			/>
			<div
				*ngIf="name?.invalid && (name?.dirty || name?.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="name?.errors?.required">Un nom est requis</span>
				<span *ngIf="name?.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="name?.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col">
			<label for="inputDescription" class="form-label theme-main-color fw-bold"
				>Description</label
			>
			<textarea
				class="form-control"
				id="inputDescription"
				formControlName="description"
				[ngClass]="{
					'is-invalid': description?.invalid,
					'is-valid': description?.dirty && description?.valid
				}"
			></textarea>
			<div
				*ngIf="
					description?.invalid && (description?.dirty || description?.touched)
				"
				class="invalid-feedback"
			>
				<span *ngIf="description?.errors?.maxlength"
					>Taille maximale atteinte</span
				>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
